import { DSGridSpacing, DSRadiusType, DSSurface, DSSurfaceProps } from '@zoe/ds-web'

import { FragmentComponent } from '@/types/graphql'

import { TypographyBlock } from './Typography'

type SurfaceRecordType = {
  __typename: 'SurfaceRecord'
  id: string
  content: any
} & Omit<DSSurfaceProps, 'children'>

const fragment = `
  fragment SurfaceBlockFragment on SurfaceBlockRecord {
    __typename
    id
    surfaceColor
    radius
    padding
    testId
    content {
      ...TypographyBlockFragment
    }
  }
`

const renderBlock = (record) => {
  const key = `${record.id}`
  switch (record.__typename) {
    case 'TypographyRecord':
      return <TypographyBlock key={key} record={record} />
  }
}

export const SurfaceBlock: FragmentComponent<{}, SurfaceRecordType> = ({ record }) => {
  // Cast from DatoCMS string
  const radius = record.radius === 'full' ? 'full' : (Number(record.radius) as DSRadiusType)
  const padding = Number(record.padding) as DSGridSpacing
  return (
    <DSSurface radius={radius} surfaceColor={record.surfaceColor} padding={padding}>
      {renderBlock(record.content)}
    </DSSurface>
  )
}

SurfaceBlock.fragment = fragment
SurfaceBlock.recordName = 'SurfaceBlock'
